/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Agents_IntroInputs */

const en_svc_agents_intro = /** @type {(inputs: Svc_Agents_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We build AI agents for one job at a time: following up on leads, answering routine email, keeping the CRM current. Each one works from your data, uses only the tools you allow, and hands anything unusual to a named person.`)
};

const lv_svc_agents_intro = /** @type {(inputs: Svc_Agents_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veidojam AI aģentus konkrētam uzdevumam: pārdošanas sarunu turpināšanai, ikdienas e-pastu atbildēm vai CRM uzturēšanai. Katrs strādā ar Jūsu datiem, izmanto tikai atļautos rīkus un neierastus gadījumus nodod konkrētam cilvēkam.`)
};

/**
* | output |
* | --- |
* | "We build AI agents for one job at a time: following up on leads, answering routine email, keeping the CRM current. Each one works from your data, uses only t..." |
*
* @param {Svc_Agents_IntroInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_agents_intro = /** @type {((inputs?: Svc_Agents_IntroInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Agents_IntroInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_agents_intro(inputs)
	return en_svc_agents_intro(inputs)
});